import showLogin from "./actions/showLogin";
import messageShow from "./actions/messageShow";
import { jwtDecode } from 'jwt-decode';


export const getAuthDataFromState=(dispatch,getState)=>
{
    const {tokenId,profileObj}=getState().login;
    return getAuthData(dispatch,{tokenId,profileObj});
};

export const getAuthDataFromGoogle = (dispatch, googleResponse) => {

  // Error genérico (GIS no manda details como antes)
  if (!googleResponse || !googleResponse.credential) {
    dispatch(
      messageShow({
        type: 'error',
        message: 'Error al autenticarse con Google'
      })
    );
    dispatch(showLogin(false));
    return;
  }

  const tokenId = googleResponse.credential;

  // Decodificar JWT (solo para UX)
  const profileObj = jwtDecode(tokenId);

  /*
    profileObj contiene:
    email, name, picture, sub, exp, aud, iss
  */

  return getAuthData(dispatch, { tokenId, profileObj });
};

export const handleBase64Response=(base64File,fileName)=>
{
    let binaryString =  window.atob(base64File);
    let binaryLen = binaryString.length;
    let ab = new ArrayBuffer(binaryLen);
    let ia = new Uint8Array(ab);
    for (let i = 0; i < binaryLen; i++) {
        ia[i] = binaryString.charCodeAt(i);
    }
    let blob = new Blob([ab]);
    let csv = window.document.createElement("a");
    csv.href = window.URL.createObjectURL(blob);
    csv.download = fileName;
    document.body.appendChild(csv);
    csv.click();
    document.body.removeChild(csv);
};

export const decodeBase64ToText=(base64File)=>
{
    if(!base64File)
        return '';

    const binaryString = window.atob(base64File);
    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }

    if (window.TextDecoder) {
        return new TextDecoder('utf-8').decode(bytes);
    }

    return binaryString;
};

const splitDelimitedLine=(line,delimiter)=>
{
    const values=[];
    let current='';
    let inQuotes=false;

    for(let i=0;i<line.length;i++) {
        const char=line[i];
        const next=line[i+1];

        if(char==='"' && inQuotes && next==='"') {
            current+='"';
            i++;
            continue;
        }

        if(char==='"') {
            inQuotes=!inQuotes;
            continue;
        }

        if(char===delimiter && !inQuotes) {
            values.push(current.trim());
            current='';
            continue;
        }

        current+=char;
    }

    values.push(current.trim());
    return values;
};

const detectDelimiter=(headerLine)=>
{
    const delimiters=[',',';','\t'];
    return delimiters
        .map(delimiter=>({delimiter,count: splitDelimitedLine(headerLine,delimiter).length}))
        .sort((a,b)=>b.count-a.count)[0].delimiter;
};

export const parseCsvText=(text)=>
{
    const cleanText=(text || '').replace(/^\uFEFF/,'').replace(/\r\n/g,'\n').replace(/\r/g,'\n').trim();

    if(!cleanText)
        return {columns:[],rows:[]};

    const lines=cleanText.split('\n').filter(line=>line.trim() !== '');
    const delimiter=detectDelimiter(lines[0]);
    const rawHeaders=splitDelimitedLine(lines[0],delimiter);
    const headers=rawHeaders.map((header,index)=>header || `Columna ${index + 1}`);

    const columns=headers.map((header,index)=>({
        title: header,
        dataIndex: `col${index}`,
        key: `col${index}`,
        ellipsis: true
    }));

    const rows=lines.slice(1).map((line,rowIndex)=>{
        const values=splitDelimitedLine(line,delimiter);
        const row={key: rowIndex};

        headers.forEach((header,columnIndex)=>{
            row[`col${columnIndex}`]=values[columnIndex] || '';
        });

        return row;
    });

    return {columns,rows};
};

export const splitReportSummaryRows=(parsedReport,summaryLabels=[])=>
{
    if(!parsedReport)
        return {report:null,summaryItems:[]};

    const labels=summaryLabels.map(label=>label.toLowerCase());
    const summaryItems=[];
    const rows=(parsedReport.rows || []).filter(row=>{
        const values=Object.keys(row)
            .filter(key=>key !== 'key')
            .map(key=>String(row[key] || '').trim());
        const matchedLabel=values.find(value=>labels.includes(value.toLowerCase()));

        if(!matchedLabel)
            return true;

        const value=values.slice().reverse().find(item=>item && item.toLowerCase() !== matchedLabel.toLowerCase());
        summaryItems.push({
            label: matchedLabel,
            value: value || ''
        });
        return false;
    }).map((row,index)=>({...row,key:index}));

    return {
        report: {...parsedReport,rows},
        summaryItems
    };
};

export const splitReportLastSummaryRow=(parsedReport,defaultLabel='Total')=>
{
    if(!parsedReport)
        return {report:null,summaryItems:[]};

    const rows=parsedReport.rows || [];

    if(rows.length===0)
        return {report:parsedReport,summaryItems:[]};

    const summaryRow=rows[rows.length - 1];
    const values=Object.keys(summaryRow)
        .filter(key=>key !== 'key')
        .map(key=>String(summaryRow[key] || '').trim())
        .filter(Boolean);
    const value=values.slice().reverse().find(item=>/\d/.test(item)) || values[values.length - 1] || '';
    const label=values.find(item=>item.toLowerCase().includes('total') && item !== value) || defaultLabel;
    const reportRows=rows.slice(0,-1).map((row,index)=>({...row,key:index}));

    return {
        report: {...parsedReport,rows:reportRows},
        summaryItems:[{
            label,
            value
        }]
    };
};

const getAuthData=(dispatch,data)=>
{
    if(!data || !data.tokenId || !data.profileObj)
    {
        dispatch(showLogin());
        return null;
    }
    return data;
};
